export default 'https://api.shop.splendorwrld.com/'
// export default 'http://localhost:3006/'
